import React from "react";
import AppBar from "@mui/material/AppBar";
import { Box, Container } from "@mui/material";
import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import { Link } from "react-router-dom";

const MainNav = () => {
  const pages = [
    { name: "About Us", path: "/aboutus" },
    { name: "My Account", path: "/account" },
    // { name: "Wishlist", path: "/wishlist" },
    // { name: "Order-Tracking", path: "/order-tracking" },
  ];

  const [anchorElNav, setAnchorElNav] = React.useState(null);

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  return (
    <AppBar
      position="static"
      style={{
        background: "transparent",
        boxShadow: "none",
        padding: "10px 0", // Adjusted padding for consistency
        fontFamily: `"Outfit", sans-serif`,
      }}
    >
      <Container maxWidth="xl">
        <Toolbar disableGutters sx={{ minHeight: "auto !important" }}>


          {/* Centered navigation links */}
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "start",
              alignItems: "center",
            }}
          >
            {pages.map((page) => (
              <Button
                key={page.name}
                component={Link}
                to={page.path}
                onClick={handleCloseNavMenu}
                sx={{
                  '& a': {
                    my: '2px',
                    padding: "0px 15px",
                  },
                  margin: '0 2px',
                  padding: "0px 15px",
                  color: "#7E7E7E",
                  display: "block",
                  fontFamily: `"Lato", sans-serif`,
                  fontWeight: 500,
                  fontSize: "13px",
                  lineHeight: "13px",
                  textTransform: "none",
                  borderRight: '1px solid #7E7E7E',
                  borderRadius: "0",
                  '& :last-child': {
                    borderRight: 'none'
                  }
                }}
              >
                {page.name}
              </Button>
            ))}
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <Typography
              //   variant="h6"
              // noWrap
              component="div"
              sx={{
                display: { xs: "none", sm: "block" },
                fontFamily: `"Lato", sans-serif`, // Use the Outfit font
                fontWeight: 600,
                fontSize: "14px",
                lineHeight: "20px",
                color: '#7E7E7E',
              }}
            >
              100% Secure delivery without contacting the courier
            </Typography>
          </Box>
          <Box
            sx={{
              flexGrow: 1,
              display: { xs: "none", md: "flex" },
              justifyContent: "end",
              alignItems: "center",
            }}
          >
            <Box
              sx={{
                '& a': {
                  my: '2px',
                  padding: "0px 15px",
                  color: '#008BFF',
                },
                margin: '0 2px',
                padding: "5px 15px",
                color: "#7E7E7E",
                display: "block",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "13px",
                textTransform: "none",
                borderRight: '1px solid #7E7E7E',
                borderRadius: "0",
              }}
            >
              Need help? Call Us:<Link to="tel:313 353 1265">313-353-1265</Link>
            </Box>
            <Box
              sx={{
                '& a': {
                  my: '2px',
                  padding: "0px 15px",
                },
                margin: '0 2px',
                padding: "0px 15px",
                color: "#7E7E7E",
                display: "block",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "13px",
                textTransform: "none",
                borderRight: '1px solid #7E7E7E',
                borderRadius: "0",
              }}
            >
              English
            </Box>
            <Box
              sx={{
                '& a': {
                  my: '2px',
                  padding: "0px 15px",
                },
                margin: '0 2px',
                padding: "0px 15px",
                color: "#7E7E7E",
                display: "block",
                fontFamily: `"Lato", sans-serif`,
                fontWeight: 500,
                fontSize: "13px",
                lineHeight: "13px",
                textTransform: "none",
                // borderRight:'1px solid #7E7E7E',
                borderRadius: "0",
              }}
            >
              USD
            </Box>
          </Box>
          {/* Donate button on the right */}
        </Toolbar>
      </Container>
    </AppBar>
  );
};

export default MainNav;
